import React from 'react';

import Slider from 'react-slick';

import { CarouselImage, CarouselSkeleton, CarouselWrapper } from './styles';

interface CarouselProps {
    imageUrls?: string[];
    isLoading?: boolean;
}

const settings = {
    autoplay: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
};

export const Carousel = ({ imageUrls, isLoading }: CarouselProps) => {
    if (isLoading || !imageUrls) {
        return <CarouselSkeleton isLoading />;
    }

    return (
        <CarouselWrapper>
            <Slider {...settings}>
                {imageUrls.map((imgUrl) => {
                    return <CarouselImage key={imgUrl} src={imgUrl} alt="Collection token" />;
                })}
            </Slider>
        </CarouselWrapper>
    );
};
